var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payResult" },
    [
      this.result == "get_brand_wcpay_request:cancel" ||
      this.result == "get_brand_wcpay_request:fail"
        ? _c(
            "van-row",
            { staticClass: "resultBar" },
            [
              _c("van-col", { staticClass: "noPayPC", attrs: { span: "24" } }),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "noPayText", attrs: { span: "24" } },
                [_vm._v("支付失败！")]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "payBtn", attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "solidBtn",
                      attrs: { round: "", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.goPath("/paydetail")
                        }
                      }
                    },
                    [_vm._v("去支付")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "payBtn", attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "hollowBtn",
                      attrs: { round: "", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.goPath("/order")
                        }
                      }
                    },
                    [_vm._v("返回列表")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.result == "get_brand_wcpay_request:ok"
        ? _c(
            "van-row",
            { staticClass: "resultBar" },
            [
              _c("van-col", {
                staticClass: "successPayPC",
                attrs: { span: "24" }
              }),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "successPayText", attrs: { span: "24" } },
                [_vm._v("支付成功！")]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "payBtn", attrs: { span: "24" } },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "hollowBtn",
                      attrs: { round: "", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.goPath("/payment")
                        }
                      }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.result == "get_brand_wcpay_request:querying"
        ? _c(
            "van-row",
            { staticClass: "resultBar" },
            [
              _c("van-col", { staticClass: "noPayPC", attrs: { span: "24" } }),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "noPayText", attrs: { span: "24" } },
                [_vm._v("支付查询中..." + _vm._s(_vm.seconds))]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "payBtn", attrs: { span: "24" } },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "hollowBtn",
                      attrs: { round: "", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.goPath("/order")
                        }
                      }
                    },
                    [_vm._v("返回列表")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.result == "get_brand_wcpay_request:exception"
        ? _c(
            "van-row",
            { staticClass: "resultBar" },
            [
              _c("van-col", { staticClass: "noPayPC", attrs: { span: "24" } }),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "noPayText", attrs: { span: "24" } },
                [_vm._v("支付异常,请在24小时内再次查询！")]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "payBtn", attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "hollowBtn",
                      attrs: { round: "", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.goPath("/order")
                        }
                      }
                    },
                    [_vm._v("返回列表")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tagBox",
          style: { height: "20%" },
          attrs: { position: "bottom" },
          model: {
            value: _vm.isTagShow,
            callback: function($$v) {
              _vm.isTagShow = $$v
            },
            expression: "isTagShow"
          }
        },
        [
          _c(
            "van-swipe",
            {
              staticClass: "tagBar",
              attrs: { loop: false, width: 100, "show-indicators": false }
            },
            _vm._l(_vm.Taglist, function(item, index) {
              return _c(
                "van-swipe-item",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.TagChange(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4ddc320", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4ddc320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/payResult.vue
// module id = null
// module chunks = 